import React, { useState, useCallback, useEffect, useRef } from "react";
// import "./onHoverStyle.css";

const SCROLL_BOX_MIN_WIDTH = 20;

export default function CustomScrollDiv({
  children,
  className,
  initAnimation,
  handleAnimation,
  needScroll,
  offset,
}) {
  const [scrollBoxWidth, setScrollBoxWidth] = useState(SCROLL_BOX_MIN_WIDTH);
  const [scrollBoxLeft, setScrollBoxLeft] = useState(0);
  const [lastScrollThumbPosition, setScrollThumbPosition] = useState(0);
  const [isDragging, setDragging] = useState(false);

  const handleDocumentMouseUp = useCallback(
    (e) => {
      if (isDragging) {
        e.preventDefault();
        setDragging(false);
      }
    },
    [isDragging]
  );

  const handleDocumentMouseMove = useCallback(
    (e) => {
      if (isDragging) {
        e.preventDefault();
        e.stopPropagation();
        const scrollHostElement = scrollHostRef.current;
        const { scrollWidth, offsetWidth } = scrollHostElement;

        let deltaX = e.clientX - lastScrollThumbPosition;
        let percentage = deltaX * (scrollWidth / offsetWidth);

        setScrollThumbPosition(e.clientX);
        setScrollBoxLeft(
          Math.min(
            Math.max(0, scrollBoxLeft + deltaX),
            offsetWidth - scrollBoxWidth
          )
        );
        scrollHostElement.scrollLeft = Math.min(
          scrollHostElement.scrollLeft + percentage,
          scrollWidth - offsetWidth
        );
      }
    },
    [isDragging, lastScrollThumbPosition, scrollBoxWidth, scrollBoxLeft]
  );

  const handleScrollThumbMouseDown = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setScrollThumbPosition(e.clientX);
    setDragging(true);
  }, []);

  const handleScroll = useCallback(() => {
    if (!scrollHostRef) {
      return;
    }
    const scrollHostElement = scrollHostRef.current;
    const { scrollLeft, scrollWidth, offsetWidth } = scrollHostElement;

    let newLeft =
      (parseInt(scrollLeft, 10) / parseInt(scrollWidth, 10)) * offsetWidth;
    // newTop = newTop + parseInt(scrollTop, 10);
    newLeft = Math.min(newLeft, offsetWidth - scrollBoxWidth);
    setScrollBoxLeft(newLeft);
  }, [scrollBoxWidth]);

  const scrollHostRef = useRef();

  useEffect(() => {
    const scrollHostElement = scrollHostRef.current;
    const { clientWidth, scrollWidth } = scrollHostElement;
    const scrollThumbPercentage = clientWidth / scrollWidth;
    const scrollThumbWidth = Math.max(
      scrollThumbPercentage * clientWidth,
      SCROLL_BOX_MIN_WIDTH
    );
    setScrollBoxWidth(scrollThumbWidth);
    scrollHostElement.addEventListener("scroll", handleScroll, true);
    return function cleanup() {
      scrollHostElement.removeEventListener("scroll", handleScroll, true);
    };
  }, [handleScroll]);

  useEffect(() => {
    //this is handle the dragging on scroll-thumb
    document.addEventListener("mousemove", handleDocumentMouseMove);
    document.addEventListener("mouseup", handleDocumentMouseUp);
    document.addEventListener("mouseleave", handleDocumentMouseUp);
    document.addEventListener("touchstart", handleDocumentMouseMove);
    document.addEventListener("touchmove", handleDocumentMouseMove);
    document.addEventListener("touchend", handleDocumentMouseMove);
    return function cleanup() {
      document.removeEventListener("mousemove", handleDocumentMouseMove);
      document.removeEventListener("mouseup", handleDocumentMouseUp);
      document.removeEventListener("mouseleave", handleDocumentMouseUp);
      document.removeEventListener("touchstart", handleDocumentMouseMove);
      document.removeEventListener("touchmove", handleDocumentMouseMove);
      document.removeEventListener("touchend", handleDocumentMouseMove);
    };
  }, [handleDocumentMouseMove, handleDocumentMouseUp]);
  const [stopAnimation, setStopAnimation] = useState(false);
  return (
    <div className={"scrollhost-container"}>
      <div
        ref={scrollHostRef}
        className={"scrollhost"}
        style={{
          scrollBehavior: initAnimation ? "smooth" : "auto",
        }}
        onClick={() => {
          initAnimation &&
            (scrollHostRef.current.scrollLeft =
              scrollHostRef.current.lastChild.offsetLeft);
          handleAnimation(false);
        }}
        onScroll={() => stopAnimation && handleAnimation(false)}
        onMouseOver={() => setStopAnimation(true)}
        onMouseEnter={() => setStopAnimation(true)}
        onTouchEnd={() => {
          initAnimation &&
            (scrollHostRef.current.scrollLeft =
              scrollHostRef.current.lastChild.offsetLeft);
          handleAnimation(false);
        }}
        onAnimationEnd={() => {
          initAnimation &&
            needScroll &&
            (scrollHostRef.current.scrollLeft = offset);
        }}
      >
        {children}
      </div>
      {needScroll && (
        <div className={"scroll-bar"}>
          <div
            className={"scroll-thumb"}
            style={{ width: scrollBoxWidth, left: scrollBoxLeft }}
            onMouseDown={(e) => {
              handleAnimation(false);
              handleScrollThumbMouseDown(e);
            }}
            onTouchStart={(e) => {
              handleAnimation(false);
              handleScrollThumbMouseDown(e);
            }}
            onTouchMove={(e) => {
              handleAnimation(false);
              handleScrollThumbMouseDown(e);
            }}
          />
        </div>
      )}
    </div>
  );
}
